import { combineReducers } from 'redux'
import { SET_CATALOG_DETAIL_SETTINGS, SET_CATALOG_OVERVIEW_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

const overview = createSettingsReducer(SET_CATALOG_OVERVIEW_SETTINGS, {
  searchTerm: '',
  filterCategory: 'all',
  filterPlatform: 'all'
})

const detail = createSettingsReducer(SET_CATALOG_DETAIL_SETTINGS, {
  searchTerm: ''
})

export default combineReducers({
  overview,
  detail
})



// WEBPACK FOOTER //
// ./reducers/application/catalog.js